import React, { useContext, useState, useRef, useCallback } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import { Button, Input } from "semantic-ui-react";
import { Checkbox, LoadingScreen } from "mapsted-components";
import { NotificationContext } from "../../../../../notifications";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { MUTATIONS } from "../../../../../../_api/queries";
import { ModalLayoutRevised } from "../../../../../common/ModaLayoutRevision/ModalLayoutRevised";

export const ImportClaimModal = ({
    // claimAccessData,
    importToProperyId,
    claimsGroupedByPropertyId,
    properties,
    refetchData,
    callbackFn,
}) => {
    const trans = useTranslation().t("Sso.ImportClaimModal");
    const propertySearchRef = useRef(null);
    const claimSearchRef = useRef(null);

    const notifications = useContext(NotificationContext);
    const [claims, setClaims] = useState([]);
    const [selectedProperty, setSelectedProperty] = useState(false);
    const [selectedClaims, setSelectedClaims] = useState([]);
    const [propertySearch, setPropertySearch] = useState("");
    const [claimSearch, setClaimSearch] = useState("");

    const handlePropertySearchChange = useCallback((e) => {
        const value = e.target.value;
        setPropertySearch(value);
        // Maintain focus after state update
        setTimeout(() => {
            if (propertySearchRef.current) {
                propertySearchRef.current.focus();
            }
        }, 0);
    }, []);

    const handleClaimSearchChange = useCallback((e) => {
        const value = e.target.value;
        setClaimSearch(value);
        // Maintain focus after state update
        setTimeout(() => {
            if (claimSearchRef.current) {
                claimSearchRef.current.focus();
            }
        }, 0);
    }, []);

    const { mutateAsync, isLoading, reset } = useMutation(
        MUTATIONS.sso.IMPORT_CLAIMS(refetchData)
    );

    const getClaimsByPropertyId = (propertyId) =>
        claimsGroupedByPropertyId?.[propertyId] || [];

    const handleSelectProperty = (id) => {
        setClaims(getClaimsByPropertyId(id));
        setSelectedProperty(id);
    };

    const handleSelectClaim = (id) => {
        if (id === "selectAll") {
            const isSelectAllChecked = !(
                claims.length === selectedClaims.length
            );
            const allClaimIds = claims.map((claim) => claim.ssoClaimId);
            setSelectedClaims(isSelectAllChecked ? allClaimIds : []);
        } else {
            const isChecked = !selectedClaims.includes(id);
            if (isChecked) {
                setSelectedClaims([...selectedClaims, id]);
            } else {
                setSelectedClaims(
                    selectedClaims.filter((claimId) => claimId !== id)
                );
            }
        }
    };

    const handleCloseModal = () => {
        reset();
        callbackFn();
    };

    const handleImport = async () => {
        try {
            if (
                !selectedProperty ||
                !selectedClaims ||
                !selectedClaims.length
            ) {
                console.log("Missing required fields.", {
                    selectedProperty,
                    selectedClaims,
                });
                return;
            }

            const claimsToImport = claims
                .filter(({ ssoClaimId }) => selectedClaims.includes(ssoClaimId))
                .map((item) => ({ ...item, propertyId: importToProperyId }));

            const data = {
                claimsToImport,
            };

            console.log("data ", data);

            await mutateAsync(data);
            reset();

            handleCloseModal();
            return;
        } catch (err) {
            console.log("err ", err);
            notifications.addNotification(
                "danger",
                "Save Request Failed.",
                err.message || "Try again later"
            );
        }
    };

    const renderProperties = () => {
        const propertiesWithClaimData = properties.filter(({ propertyId }) =>
            claimsGroupedByPropertyId?.[propertyId] &&
                propertyId !== importToProperyId
                ? true
                : false
        );

        const filterBySearch = propertySearch
            ? properties?.filter(
                ({ propertyId, name }) =>
                    propertyId === propertySearch ||
                    name?.toLowerCase().includes(propertySearch.toLowerCase())
            )
            : properties;

        return filterBySearch
            ?.sort((a, b) => a?.name?.localeCompare(b?.name))
            ?.map(({ propertyId, name }) => (
                <div key={propertyId} className="property-item">
                    <Checkbox
                        checked={selectedProperty === propertyId}
                        onClick={(e) => handleSelectProperty(propertyId)}
                        radio
                        label={name}
                        // label={
                        //     <span>
                        //         {name} (${propertyId})
                        //     </span>
                        // }
                        name={name}
                    />
                </div>
            ));
    };

    const renderClaims = () => {
        const filtered = claimSearch
            ? claims?.filter((item) =>
                item?.claimName
                    ?.toLowerCase()
                    .includes(claimSearch.toLowerCase())
            )
            : claims;
        const sortedArray = filtered?.sort((a, b) =>
            a?.claimName?.localeCompare(b?.claimName)
        );
        const addSelectAllOption = sortedArray?.length
            ? [
                { ssoClaimId: "selectAll", claimName: "Select All" },
                ...sortedArray,
            ]
            : sortedArray;
        return addSelectAllOption?.map(({ ssoClaimId, claimName }) => (
            <div key={ssoClaimId} className="property-item">
                <Checkbox
                    checked={
                        selectedClaims.includes(ssoClaimId) ||
                        selectedClaims?.length === claims.length
                    }
                    onClick={() => handleSelectClaim(ssoClaimId)}
                    // radio
                    label={claimName}
                    name={claimName}
                />
            </div>
        ));
    };

    const isDisableImportBtn = !selectedClaims || !selectedClaims.length;
    return (
        <ModalLayoutRevised
            open={true}
            onClose={() => handleCloseModal()}
            customHeading={
                <>
                    {trans["Title"]}
                    <p className="sub-heading">{trans["Sub_Title"]}</p>
                </>
            }
            hideClose={false}
            actions={<Button
                color="orange"
                type="button"
                floated="right"
                content={trans["Import"]}
                className="submit-btn import-btn"
                onClick={handleImport}
                disabled={isDisableImportBtn}
            />}
            className="import-claim-modal"
        >

            {isLoading && <LoadingScreen />}

            <div className="import-warning">
                <div className="warning-text">
                    <strong>{trans["Warning"]}</strong>
                    {trans["Warning_Msg"]}
                </div>
            </div>

            <div className="claimModal-login-section">
                <div className="import-section-label order-1">
                    {trans["Select_Property"]}
                </div>
                <div className="import-section-label order-3">
                    {trans["Select_To_Import"]}
                </div>
                <div className="property-section-container order-2">
                    <div className="property-section-label">
                        {trans["Property_Title"]}
                    </div>
                    <div className="property-section-content">
                        <Input
                            key="property-search"
                            ref={propertySearchRef}
                            // disabled={isLoading}
                            id="propertySearch"
                            light="true"
                            className="inputForm searchDashboard"
                            icon="search"
                            placeholder={trans["Search"]}
                            value={propertySearch}
                            onChange={handlePropertySearchChange}
                        />
                        <Scrollbars
                            autohide="true"
                            autoHeight
                            autoHeightMin={"calc(1vh)"}
                            autoHeightMax={"194px"}
                        >
                            <div className="alignerScroll alignerHeight property-list-container">
                                {renderProperties()}
                            </div>
                        </Scrollbars>
                        {/* </div> */}
                    </div>
                </div>
                <div className="claim-section-container order-4">
                    <div className="claim-section-label">
                        {trans["Sso_Claim"]}
                    </div>
                    <div className="claim-section-content">
                        <Input
                            key="claim-search"
                            ref={claimSearchRef}
                            // disabled={isLoading}
                            id="claimSearch"
                            light="true"
                            className="inputForm searchDashboard"
                            icon="search"
                            placeholder={trans["Search"]}
                            value={claimSearch}
                            onChange={handleClaimSearchChange}
                        />
                        <Scrollbars
                            autohide="true"
                            autoHeight
                            autoHeightMin={"calc(1vh)"}
                            autoHeightMax={"194px"}
                        >
                            <div className="alignerScroll alignerHeight property-list-container">
                                {renderClaims()}
                            </div>
                        </Scrollbars>
                    </div>
                </div>
            </div>
        </ModalLayoutRevised>
    );
};
